export default __webpack_public_path__ + "static/media/pivot-trading-partner.4c35616b.svg";